import {Container, Grid} from '@mui/material';
import React from 'react';
import {Route, Routes} from 'react-router-dom';
import MfaCodePage from '../../pages/MfaCodePage/MfaCodePage';
import MfaEnrolledPage from '../../pages/MfaEnrolledPage/MfaEnrolledPage';
import MfaEnrolmentAppPage from '../../pages/MfaEnrolmentAppPage/MfaEnrolmentAppPage';
import MfaEnrolmentPage from '../../pages/MfaEnrolmentPage/MfaEnrolmentPage';
import MfaEnrolmentSmsPage from '../../pages/MfaEnrolmentSmsPage/MfaEnrolmentSmsPage';
import theme, {themeColors} from '../../theme/Theme';

function MfaEnrolmentRoutes() {
  return (
    <Grid
      container
      sx={{
        alignItems: 'center',
        color: themeColors.white,
        position: 'fixed',
        [theme.breakpoints.down('xl')]: {
          position: 'relative',
        },
        top: 0,
        height: '100vh',
        overflow: 'auto',
        backgroundColor: themeColors.backgroundDark,
      }}
    >
      <Container maxWidth="lg">
        <Grid container>
          <Grid
            sx={{
              order: 6,
            }}
            item
            xs={12}
          >
            <Routes>
              <Route index element={<MfaEnrolmentPage />} />
              <Route path="app" element={<MfaEnrolmentAppPage />} />
              <Route path="code/:pathway" element={<MfaCodePage />} />
              <Route path="enrolled/:pathway" element={<MfaEnrolledPage />} />
              <Route path="sms" element={<MfaEnrolmentSmsPage />} />
            </Routes>
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
}

export default MfaEnrolmentRoutes;
